"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f114 = void 0;
exports.f114 = {
    "republic": [
        2539,
        2540,
        568,
        674,
        899,
        1023,
        1807,
        3466,
        3490,
        3518,
        3569,
        3668,
        3814,
        4001,
        4276,
        4942,
        5082,
        5423,
        5424,
        5571,
        5772,
        6249,
        6995,
        6996,
        7026,
        7219,
        8722,
        9103,
        2982,
        3378,
        3847,
        3848,
        3850,
        4055,
        5882,
        5884,
        6169,
        9148,
        24,
        112,
        113,
        114,
        157,
        182,
        219,
        266,
        281,
        307,
        308,
        309,
        310,
        368,
        430,
        435,
        437,
        460,
        480,
        497,
        534,
        593,
        596,
        599,
        638,
        646,
        649,
        679,
        700,
        703,
        704,
        740,
        747,
        754,
        788,
        789,
        834,
        849,
        858,
        859,
        874,
        889,
        890,
        893,
        903,
        919,
        934,
        945,
        948,
        950,
        955,
        980,
        994,
        1007,
        1019,
        1028,
        1033,
        1058,
        1060,
        1070,
        1079,
        1083,
        1091,
        1101,
        1102,
        1103,
        1121,
        1176,
        1190,
        1212,
        1233,
        1241,
        1244,
        1254,
        1279,
        1309,
        1311,
        1378,
        1497,
        1549,
        1627,
        1628,
        1633,
        1703,
        1705,
        1715,
        1796,
        1812,
        1821,
        1840,
        1867,
        1916,
        1923,
        1933,
        1942,
        1944,
        2049,
        2065,
        2101,
        2216,
        2267,
        2290,
        2329,
        2347,
        2348,
        2389,
        2401,
        2412,
        2426,
        2427,
        2459,
        2496,
        2545,
        2555,
        2556,
        2560,
        2564,
        2583,
        2608,
        2613,
        2656,
        2680,
        2681,
        2700,
        2722,
        2730,
        2749,
        2750,
        2752,
        2792,
        2845,
        2862,
        2872,
        2884,
        2898,
        2901,
        2906,
        2909,
        2911,
        2925,
        2927,
        2956,
        2957,
        3005,
        3006,
        3007,
        3014,
        3031,
        3057,
        3067,
        3083,
        3191,
        3238,
        3240,
        3255,
        3285,
        3347,
        3355,
        3374,
        3391,
        3410,
        3486,
        3526,
        3527,
        3528,
        3531,
        3533,
        3535,
        3537,
        3552,
        3561,
        3604,
        3620,
        3631,
        3650,
        3656,
        3657,
        3667,
        3689,
        3693,
        3702,
        3703,
        3732,
        3744,
        3753,
        3773,
        3817,
        3845,
        3849,
        3885,
        3905,
        3955,
        3969,
        3975,
        3987,
        3993,
        4005,
        4019,
        4023,
        4037,
        4090,
        4096,
        4132,
        4144,
        4147,
        4183,
        4195,
        4204,
        4224,
        4229,
        4230,
        4231,
        4266,
        4269,
        4274,
        4284,
        4306,
        4312,
        4320,
        4328,
        4334,
        4347,
        4348,
        4363,
        4401,
        4419,
        4421,
        4423,
        4431,
        4438,
        4439,
        4445,
        4450,
        4454,
        4456,
        4475,
        4481,
        4489,
        4492,
        4499,
        4517,
        4518,
        4524,
        4541,
        4545,
        4548,
        4592,
        4648,
        4660,
        4661,
        4662,
        4664,
        4665,
        4666,
        4667,
        4710,
        4753,
        4757,
        4759,
        4762,
        4763,
        4764,
        4765,
        4770,
        4823,
        4879,
        4880,
        4925,
        4984,
        5171,
        5178,
        5199,
        5202,
        5203,
        5204,
        5212,
        5234,
        5254,
        5269,
        5277,
        5313,
        5320,
        5331,
        5349,
        5350,
        5364,
        5365,
        5367,
        5368,
        5369,
        5377,
        5380,
        5382,
        5408,
        5421,
        5422,
        5426,
        5434,
        5435,
        5438,
        5474,
        5479,
        5490,
        5491,
        5495,
        5530,
        5533,
        5549,
        5553,
        5592,
        5609,
        5633,
        5638,
        5687,
        5715,
        5717,
        5724,
        5728,
        5746,
        5775,
        5789,
        5793,
        5796,
        5799,
        5803,
        5811,
        5814,
        5816,
        5824,
        5873,
        5877,
        5892,
        5908,
        5910,
        5938,
        6007,
        6018,
        6021,
        6028,
        6055,
        6100,
        6101,
        6129,
        6130,
        6134,
        6162,
        6178,
        6204,
        6247,
        6252,
        6267,
        6275,
        6285,
        6309,
        6363,
        6443,
        6474,
        6491,
        6495,
        6524,
        6560,
        6568,
        6574,
        6585,
        6621,
        6624,
        6638,
        6639,
        6661,
        6701,
        6703,
        6706,
        6717,
        6736,
        6753,
        6780,
        6804,
        6821,
        6832,
        6844,
        6852,
        6887,
        6932,
        6953,
        6956,
        6959,
        6986,
        6987,
        6999,
        7027,
        7028,
        7035,
        7038,
        7039,
        7048,
        7065,
        7078,
        7080,
        7081,
        7126,
        7130,
        7147,
        7188,
        7193,
        7194,
        7205,
        7223,
        7224,
        7225,
        7230,
        7231,
        7232,
        7234,
        7235,
        7275,
        7287,
        7315,
        7341,
        7347,
        7357,
        7389,
        7418,
        7459,
        7474,
        7503,
        7534,
        7549,
        7572,
        7609,
        7632,
        7636,
        7652,
        7655,
        7672,
        7762,
        7769,
        7774,
        7879,
        7894,
        7920,
        7934,
        8046,
        8047,
        8061,
        8082,
        8086,
        8111,
        8144,
        8179,
        8180,
        8181,
        8246,
        8316,
        8366,
        8494,
        8500,
        8504,
        8505,
        8529,
        8561,
        8604,
        8659,
        8660,
        8727,
        8763,
        8774,
        8826,
        8843,
        8861,
        8867,
        8878,
        8932,
        8979,
        8980,
        9012,
        9056,
        9057,
        9074,
        9082,
        9086,
        9096,
        9097,
        9099,
        9106,
        9108
    ],
    "river": [
        3917,
        4723,
        8503,
        627,
        903,
        3427,
        4978,
        26,
        80,
        193,
        553,
        561,
        1562,
        2411,
        2983,
        3291,
        3737,
        4652,
        5604,
        6017,
        6018,
        6019,
        7647,
        7686,
        7799,
        7956,
        8023,
        8260,
        8927
    ],
    "ru": [
        1481,
        47,
        108,
        109,
        173,
        202,
        252,
        274,
        275,
        276,
        323,
        395,
        505,
        532,
        597,
        609,
        1031,
        1170,
        1405,
        1406,
        1407,
        1447,
        1448,
        1483,
        1491,
        1492,
        1508,
        1527,
        1677,
        1678,
        1699,
        1740,
        1778,
        1892,
        2231,
        2232,
        2317,
        2318,
        2320,
        2590,
        2648,
        2677,
        3095,
        3215,
        3216,
        3217,
        3270,
        3299,
        3341,
        3342,
        3472,
        3481,
        3506,
        3577,
        3665,
        3682,
        3705,
        3858,
        3859,
        3860,
        3892,
        3896,
        3929,
        3936,
        3937,
        3938,
        4026,
        4027,
        4028,
        4041,
        4042,
        4043,
        4044,
        4045,
        4221,
        4291,
        4520,
        4657,
        4953,
        5049,
        5113,
        5129,
        5250,
        5363,
        5395,
        5481,
        5487,
        5488,
        5624,
        5822,
        5823,
        5896,
        5909,
        5961,
        5966,
        5967,
        5968,
        6433,
        6603,
        6608,
        6610,
        6612,
        6630,
        6664,
        6665,
        6786,
        6866,
        6891,
        6907,
        6981,
        7097,
        7182,
        7302,
        7508,
        7548,
        7753,
        7754,
        7875,
        7906,
        7911,
        7912,
        7946,
        8074,
        8133,
        8134,
        8388,
        8398,
        8406,
        8599,
        8621,
        8622,
        8641,
        8698,
        8816,
        8862,
        8895,
        8911,
        8928,
        8940,
        9060,
        9066,
        9073
    ],
    "russian federation": [
        47,
        108,
        109,
        173,
        202,
        252,
        274,
        275,
        276,
        323,
        395,
        505,
        532,
        597,
        609,
        1031,
        1170,
        1405,
        1406,
        1407,
        1447,
        1448,
        1483,
        1491,
        1492,
        1508,
        1527,
        1677,
        1678,
        1699,
        1740,
        1778,
        1892,
        2231,
        2232,
        2317,
        2318,
        2320,
        2590,
        2648,
        2677,
        3095,
        3215,
        3216,
        3217,
        3270,
        3299,
        3341,
        3342,
        3472,
        3481,
        3506,
        3577,
        3665,
        3682,
        3705,
        3858,
        3859,
        3860,
        3892,
        3896,
        3929,
        3936,
        3937,
        3938,
        4026,
        4027,
        4028,
        4041,
        4042,
        4043,
        4044,
        4045,
        4221,
        4291,
        4520,
        4657,
        4953,
        5049,
        5113,
        5129,
        5250,
        5363,
        5395,
        5481,
        5487,
        5488,
        5624,
        5822,
        5823,
        5896,
        5909,
        5961,
        5966,
        5967,
        5968,
        6433,
        6603,
        6608,
        6610,
        6612,
        6630,
        6664,
        6665,
        6786,
        6866,
        6891,
        6907,
        6981,
        7097,
        7182,
        7302,
        7508,
        7548,
        7753,
        7754,
        7875,
        7906,
        7911,
        7912,
        7946,
        8074,
        8133,
        8134,
        8388,
        8398,
        8406,
        8599,
        8621,
        8622,
        8641,
        8698,
        8816,
        8862,
        8895,
        8911,
        8928,
        8940,
        9060,
        9066,
        9073
    ],
    "russian": [
        6603,
        6610,
        6611,
        6612,
        6613,
        6614,
        6615,
        6616,
        5961,
        6980,
        711,
        712,
        713,
        47,
        108,
        109,
        173,
        202,
        252,
        274,
        275,
        276,
        323,
        395,
        505,
        532,
        597,
        609,
        1031,
        1170,
        1405,
        1406,
        1407,
        1447,
        1448,
        1483,
        1491,
        1492,
        1508,
        1527,
        1677,
        1678,
        1699,
        1740,
        1778,
        1892,
        2231,
        2232,
        2317,
        2318,
        2320,
        2590,
        2648,
        2677,
        3095,
        3215,
        3216,
        3217,
        3270,
        3299,
        3341,
        3342,
        3472,
        3481,
        3506,
        3577,
        3665,
        3682,
        3705,
        3858,
        3859,
        3860,
        3892,
        3896,
        3929,
        3936,
        3937,
        3938,
        4026,
        4027,
        4028,
        4041,
        4042,
        4043,
        4044,
        4045,
        4221,
        4291,
        4520,
        4657,
        4953,
        5049,
        5113,
        5129,
        5250,
        5363,
        5395,
        5481,
        5487,
        5488,
        5624,
        5822,
        5823,
        5896,
        5909,
        5966,
        5967,
        5968,
        6433,
        6608,
        6630,
        6664,
        6665,
        6786,
        6866,
        6891,
        6907,
        6981,
        7097,
        7182,
        7302,
        7508,
        7548,
        7753,
        7754,
        7875,
        7906,
        7911,
        7912,
        7946,
        8074,
        8133,
        8134,
        8388,
        8398,
        8406,
        8599,
        8621,
        8622,
        8641,
        8698,
        8816,
        8862,
        8895,
        8911,
        8928,
        8940,
        9060,
        9066,
        9073
    ],
    "rabinal": [
        76
    ],
    "rashaida": [
        81
    ],
    "rashida": [
        81
    ],
    "raklu un": [
        88
    ],
    "raklu": [
        88
    ],
    "raklu-un": [
        88
    ],
    "rib": [
        115
    ],
    "ribh": [
        115
    ],
    "remontado": [
        171
    ],
    "remontado agta": [
        171
    ],
    "remontado dumagat": [
        171
    ],
    "ramon": [
        175
    ],
    "ring": [
        376,
        1696,
        3768
    ],
    "raga": [
        384,
        4405
    ],
    "ree": [
        442
    ],
    "ris": [
        442
    ],
    "ranquel": [
        446
    ],
    "rondonia": [
        450
    ],
    "ramarama": [
        450,
        8008
    ],
    "rodonia": [
        455
    ],
    "rugnot": [
        495
    ],
    "rugnot of lake buhi east": [
        495
    ],
    "reel": [
        504
    ],
    "rëël": [
        504
    ],
    "ruruhip": [
        518,
        6516
    ],
    "reo tuhaa pae": [
        526
    ],
    "reo": [
        4790,
        6591,
        526,
        5062,
        6484,
        7860,
        6472
    ],
    "ra:kudi": [
        550
    ],
    "rio": [
        1131,
        2578,
        2724,
        3056,
        3562,
        567,
        3474,
        4921,
        8240
    ],
    "rai": [
        2030,
        818,
        6511,
        624,
        2012,
        2105,
        3419,
        3420,
        3756,
        3768,
        3781,
        6455,
        6458,
        6471,
        6476,
        7392,
        8751
    ],
    "river jarawa": [
        627
    ],
    "rambi": [
        642
    ],
    "rombi": [
        642,
        4401
    ],
    "ruthenian": [
        6619,
        6620,
        711,
        712,
        713
    ],
    "rang": [
        6483,
        719,
        6572,
        6586
    ],
    "rang lo": [
        719
    ],
    "riok": [
        7105,
        723
    ],
    "remo": [
        6500,
        771,
        5726
    ],
    "remosum": [
        771
    ],
    "riwai": [
        773
    ],
    "rathwi": [
        782,
        6609
    ],
    "rathi": [
        782
    ],
    "rathia": [
        782
    ],
    "rathwi bareli": [
        782
    ],
    "rathwi pauri": [
        782
    ],
    "rumeli türkçesi": [
        801,
        802
    ],
    "rumeli": [
        801,
        802
    ],
    "rumelian turkish": [
        801,
        802
    ],
    "rumelian": [
        801,
        802
    ],
    "radu lo": [
        818
    ],
    "radu": [
        818,
        8275
    ],
    "rfʊ": [
        854
    ],
    "r": [
        854
    ],
    "rebu": [
        858,
        980,
        4979
    ],
    "river ruki": [
        903
    ],
    "ruki": [
        903
    ],
    "red": [
        2651,
        1022,
        2089,
        3283,
        3284,
        3285,
        3286,
        3287,
        4007,
        4009,
        4010,
        4012,
        4014,
        4152,
        4153,
        4154,
        4824,
        4918,
        5139,
        5723,
        6191,
        7524,
        7870,
        8804,
        960,
        8792
    ],
    "rema": [
        1021
    ],
    "red bobo": [
        1022
    ],
    "rote": [
        1921,
        6595,
        7853,
        1049,
        4380,
        6512,
        7835
    ],
    "rote timur": [
        1049,
        6512
    ],
    "roti": [
        1049,
        1921,
        4380,
        6512,
        6595,
        7835,
        7853
    ],
    "rotinese": [
        1049,
        1921,
        4380,
        6512,
        6595,
        7835,
        7853
    ],
    "rawe": [
        1078,
        1079,
        1080
    ],
    "rica": [
        1092,
        1299,
        1490,
        1648,
        2265,
        2821
    ],
    "rio pongo baga": [
        1131
    ],
    "ratagnon": [
        1155
    ],
    "rinconada": [
        1156
    ],
    "rinconada bicolano": [
        1156
    ],
    "rinconada bikol": [
        1156
    ],
    "riŋkonāda": [
        1156
    ],
    "russia": [
        1447,
        1448,
        6433,
        1170
    ],
    "rappang buginese": [
        1177,
        1178
    ],
    "rappang": [
        1177,
        1178
    ],
    "rue": [
        1228
    ],
    "rubasa": [
        1319
    ],
    "rubassa": [
        1319
    ],
    "refalúwasch": [
        1339
    ],
    "rem": [
        1388,
        1389,
        3805
    ],
    "riem": [
        1388,
        1389
    ],
    "rengcaa": [
        1420,
        1421
    ],
    "rukiga": [
        1435
    ],
    "runyankore-rukiga": [
        1435
    ],
    "rtsamangpa’ikha": [
        1436
    ],
    "rtsamangpa’i kha": [
        1436
    ],
    "rtsamangpa’i": [
        1436
    ],
    "ruk": [
        1445
    ],
    "ron": [
        1514,
        6571
    ],
    "rong": [
        1541,
        4439
    ],
    "rupshu": [
        1541
    ],
    "raljago": [
        1600
    ],
    "ro": [
        3122,
        6564,
        1622,
        6559,
        6575,
        6576,
        6578,
        6579,
        6588,
        6589,
        6627,
        7096
    ],
    "rosa": [
        1626,
        3226,
        6373,
        6424
    ],
    "rican": [
        1648,
        6315
    ],
    "rûng": [
        1667,
        1692
    ],
    "rigsdansk": [
        1719,
        1720
    ],
    "ruwa": [
        1793
    ],
    "rugciriku": [
        1863
    ],
    "rumanyo": [
        1863
    ],
    "rusambyu": [
        1863
    ],
    "reef": [
        1865,
        5417
    ],
    "rote barat": [
        1921,
        6595,
        7853
    ],
    "rungus": [
        1958
    ],
    "roongas": [
        1958
    ],
    "rungus dusun": [
        1958
    ],
    "rukai": [
        1966
    ],
    "rutkai": [
        1966
    ],
    "reč": [
        1968
    ],
    "reshiat": [
        1970
    ],
    "rathod": [
        1996
    ],
    "rāī": [
        2012
    ],
    "ro’do bo’": [
        2012
    ],
    "ro’do": [
        2012
    ],
    "rawang": [
        6477,
        6478,
        6479,
        6480,
        6481,
        6482,
        2013
    ],
    "rai danuwar": [
        2030
    ],
    "reggiano": [
        2068
    ],
    "red karen": [
        2089,
        4152,
        4153,
        4154
    ],
    "romaic": [
        2090,
        2091,
        2093
    ],
    "romani": [
        6542,
        6545,
        6550,
        6551,
        6553,
        6554,
        6555,
        6556,
        6561,
        6563,
        6590,
        6588,
        6626,
        2115,
        6544,
        6558,
        6560
    ],
    "rico": [
        2196,
        2280,
        6315,
        7628
    ],
    "rw": [
        2198,
        2456,
        6635,
        6636
    ],
    "rwanda": [
        6635,
        6636,
        2198,
        2456
    ],
    "rgu": [
        2251
    ],
    "rtau": [
        2251
    ],
    "raj gond": [
        2287,
        2288,
        2289,
        8343,
        8344,
        8345,
        8346
    ],
    "raj": [
        2287,
        2288,
        2289,
        3591,
        3592,
        3593,
        3594,
        8343,
        8344,
        8345,
        8346
    ],
    "re": [
        2455,
        6490
    ],
    "réunion": [
        6490,
        2455
    ],
    "romand": [
        2471
    ],
    "rajput": [
        2761,
        2762,
        2574,
        2549,
        2550
    ],
    "rajput lohar": [
        2574
    ],
    "ragetta": [
        2578
    ],
    "rawam": [
        2611
    ],
    "ril-lila": [
        2629,
        2630
    ],
    "red gelao": [
        2651
    ],
    "rajasthani": [
        6463,
        6464,
        5153,
        5154,
        6643,
        2665,
        2666
    ],
    "rajasthani gujuri": [
        2665,
        2666
    ],
    "rio arauca guahibo": [
        2724
    ],
    "rtchi": [
        2748
    ],
    "rajput garasia": [
        2761,
        2762
    ],
    "rondônia": [
        2835,
        4032,
        7120
    ],
    "rautsuiiri": [
        2889
    ],
    "ruha": [
        2901
    ],
    "ruhaa": [
        2901
    ],
    "ruhaya": [
        2909
    ],
    "rukobi": [
        2957
    ],
    "republic of korea": [
        2982,
        3378,
        3847,
        3848,
        3850,
        4055,
        5882,
        5884,
        6169,
        9148
    ],
    "rifi": [
        6519,
        6520,
        6521,
        6522,
        3026
    ],
    "rangkhol": [
        3045
    ],
    "riograndense": [
        3056
    ],
    "rio grand hunsriker": [
        3056
    ],
    "riograndenser hunsrickisch": [
        3056
    ],
    "riograndenser": [
        3056
    ],
    "rěč": [
        3058
    ],
    "ro bambami": [
        3122
    ],
    "rigwe": [
        3237
    ],
    "rocky peak": [
        3273
    ],
    "rocky": [
        3273
    ],
    "red dao": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "rongba": [
        3339,
        7599
    ],
    "rawat": [
        3406
    ],
    "rauts": [
        3406
    ],
    "raji": [
        6530,
        3406,
        6475
    ],
    "raut": [
        3406
    ],
    "river jukun": [
        3427
    ],
    "rgyarong": [
        3449
    ],
    "rio grande keresan": [
        3562
    ],
    "raj koya": [
        3591,
        3592,
        3593,
        3594
    ],
    "ramekhera": [
        3608
    ],
    "rere": [
        3672
    ],
    "ramopa": [
        3725
    ],
    "rumu": [
        3780
    ],
    "rumuhei": [
        3780
    ],
    "rumuwa": [
        3780
    ],
    "rumū heì": [
        3780
    ],
    "rumū": [
        3780
    ],
    "rukonjo": [
        3863
    ],
    "ruilak": [
        3893
    ],
    "rishuwa": [
        3954
    ],
    "rikpa": [
        3959
    ],
    "rikpa’": [
        3959
    ],
    "ripuarian": [
        3961
    ],
    "ripuarisch": [
        3961
    ],
    "red kurmanji": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "rimba": [
        4046
    ],
    "rukwangari": [
        4086
    ],
    "rukwángali": [
        4086
    ],
    "rapoisi": [
        4159
    ],
    "romance": [
        4189,
        4190,
        4191
    ],
    "romance espanyol": [
        4189,
        4190,
        4191
    ],
    "rangi": [
        4195
    ],
    "rambia": [
        4201
    ],
    "rangloi": [
        4222,
        4223
    ],
    "rmeet": [
        4229,
        4230
    ],
    "rumbathama": [
        4240
    ],
    "rega": [
        4266,
        4306
    ],
    "rik’a": [
        4268
    ],
    "rongke": [
        4280,
        4281
    ],
    "rongpa": [
        4280,
        4281
    ],
    "róng": [
        4280,
        4281
    ],
    "róng-ríng": [
        4280,
        4281
    ],
    "róngkup": [
        4280,
        4281
    ],
    "ruavatu": [
        4309
    ],
    "riahoma": [
        4310
    ],
    "rampi": [
        4350
    ],
    "rampi-leboni": [
        4350
    ],
    "remun": [
        4364
    ],
    "remun iban": [
        4364
    ],
    "rhaeto-romance": [
        4377,
        6539
    ],
    "rote lole": [
        4380
    ],
    "rote tengah": [
        4380,
        7835
    ],
    "rumbi": [
        4401
    ],
    "rumli": [
        4401
    ],
    "raxa": [
        4405
    ],
    "rong kong": [
        4439
    ],
    "rop": [
        4455
    ],
    "rotse": [
        4467
    ],
    "rotvi": [
        4467
    ],
    "rozi": [
        4467
    ],
    "rutse": [
        4467
    ],
    "rara": [
        4474
    ],
    "rara bakati'": [
        4474
    ],
    "rara bakati’": [
        4474
    ],
    "ruund": [
        6568,
        4528
    ],
    "ruliy luri": [
        4541
    ],
    "ruliy": [
        4541
    ],
    "russell island": [
        4546
    ],
    "russell": [
        4546
    ],
    "rouyi": [
        4563
    ],
    "ranchos": [
        4593
    ],
    "rumbala": [
        4666
    ],
    "raffles bay": [
        4773
    ],
    "raffles": [
        4773
    ],
    "raṭnā": [
        4795
    ],
    "red trouser yao": [
        4824
    ],
    "rajmahali": [
        4836,
        4837
    ],
    "rral": [
        4907
    ],
    "reddi": [
        4911
    ],
    "reddi-dora": [
        4911
    ],
    "riddi": [
        4911
    ],
    "red meo": [
        4918,
        5139
    ],
    "red miao": [
        4918,
        5139
    ],
    "rennell-bellona": [
        4955
    ],
    "rennell": [
        4955
    ],
    "rennellese": [
        6602,
        4955
    ],
    "rennellese-bellonese": [
        4955
    ],
    "raman": [
        4956
    ],
    "rman": [
        4956
    ],
    "rmen": [
        4956
    ],
    "river yuman": [
        4978
    ],
    "rajah": [
        5019
    ],
    "rajah kabungsuan manobo": [
        5019
    ],
    "rajah kabunsuwan manobo": [
        5019
    ],
    "reih": [
        5048
    ],
    "reo magareva": [
        5062
    ],
    "ranao": [
        5063
    ],
    "rongd": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "roea": [
        5253
    ],
    "rongmei": [
        5329
    ],
    "rongmai": [
        5329
    ],
    "rongmei naga": [
        5329
    ],
    "rahau ponam": [
        5336
    ],
    "rahau": [
        5336
    ],
    "ra": [
        5337,
        6037
    ],
    "rito": [
        5382,
        5383
    ],
    "ruto": [
        5382,
        5383
    ],
    "reef islands": [
        5417
    ],
    "reefs": [
        5417
    ],
    "randfa": [
        5480
    ],
    "runyoro": [
        5490,
        5801
    ],
    "rifao": [
        5586
    ],
    "rengma": [
        5603,
        5666,
        5647
    ],
    "ragwe": [
        5638
    ],
    "rukaragwe": [
        5638
    ],
    "runyambo": [
        5638
    ],
    "rengma naga": [
        5666
    ],
    "rangpan": [
        5701,
        5702,
        5703
    ],
    "rangpang": [
        5701,
        5702,
        5703
    ],
    "red mantsi": [
        5723
    ],
    "rheno": [
        5726,
        6500
    ],
    "rokka": [
        5774
    ],
    "runyankore": [
        5800
    ],
    "runyankole": [
        5800
    ],
    "rostam": [
        5877
    ],
    "rd-th": [
        5884
    ],
    "roamaina": [
        5916
    ],
    "reyes": [
        6045
    ],
    "roubaignot": [
        6064
    ],
    "rouchi": [
        6064
    ],
    "ruching": [
        6065,
        6066
    ],
    "ruching palaung": [
        6065,
        6066
    ],
    "rheinfrankisch": [
        6110
    ],
    "rhine franconian": [
        6110
    ],
    "rhine": [
        6110
    ],
    "rerep": [
        6115
    ],
    "red da’ang": [
        6191
    ],
    "rin": [
        6228
    ],
    "romayka": [
        6241,
        6242,
        6243
    ],
    "romeika": [
        6241,
        6242,
        6243
    ],
    "romeyka": [
        6241,
        6242,
        6243
    ],
    "rumca": [
        6241,
        6242,
        6243
    ],
    "rumcika": [
        6241,
        6242,
        6243
    ],
    "rumka": [
        6241,
        6242,
        6243
    ],
    "runasimi": [
        6393,
        6394,
        6395,
        6417,
        6447,
        6414
    ],
    "runasimi qusqu qullaw": [
        6393
    ],
    "runa shimi": [
        6397,
        6429,
        6438,
        6399,
        6400,
        6401,
        6407,
        6412,
        6419,
        6420,
        6422,
        6423,
        6424,
        6432,
        6444
    ],
    "runa": [
        6397,
        6418,
        6427,
        6429,
        6438,
        6439,
        6399,
        6400,
        6401,
        6407,
        6409,
        6412,
        6419,
        6420,
        6422,
        6423,
        6424,
        6430,
        6432,
        6440,
        6441,
        6442,
        6444
    ],
    "runashimi": [
        6400,
        6426
    ],
    "runa simi": [
        6418,
        6427,
        6409,
        6430,
        6440,
        6441,
        6442
    ],
    "rafael-huariaca": [
        6415
    ],
    "runacuna": [
        6438
    ],
    "runa shimibi": [
        6439
    ],
    "rrmea": [
        6445
    ],
    "rodong": [
        6455
    ],
    "rasawa": [
        6456
    ],
    "rade": [
        6457
    ],
    "raday": [
        6457
    ],
    "rde": [
        6457
    ],
    "rhade": [
        6457
    ],
    "ragoli": [
        6459
    ],
    "rabha": [
        6460,
        6461
    ],
    "rava": [
        6460,
        6461
    ],
    "rába katha": [
        6460,
        6461
    ],
    "rába": [
        6460,
        6461
    ],
    "ramoaaina": [
        6462
    ],
    "ramuaina": [
        6462
    ],
    "ralte": [
        6466
    ],
    "riantana": [
        6468
    ],
    "rao": [
        6469,
        7372
    ],
    "rao breri": [
        6469
    ],
    "rapa nui": [
        6470
    ],
    "rapa": [
        6470,
        6484
    ],
    "rapanui": [
        6470
    ],
    "rarotongan": [
        6472
    ],
    "razajerdi": [
        6474
    ],
    "raute": [
        6475
    ],
    "rajwar": [
        6475
    ],
    "rautya": [
        6475
    ],
    "rautye": [
        6475
    ],
    "ra’te": [
        6475
    ],
    "rvwang": [
        6477,
        6478,
        6479,
        6480,
        6481,
        6482
    ],
    "rvwangka": [
        6477,
        6478,
        6479,
        6480,
        6481,
        6482
    ],
    "rawang, daru-zerwang": [
        6478
    ],
    "rawang, longmi north mashang dangraq": [
        6479
    ],
    "rawang, longmi south": [
        6480
    ],
    "rawang, tangsarr east - marangdong, jigong": [
        6481
    ],
    "rawang, tangsarr west dakhum": [
        6482
    ],
    "rapan": [
        6484
    ],
    "reo rapa": [
        6484
    ],
    "rahambuu": [
        6485
    ],
    "rumai": [
        6486
    ],
    "rumai humai": [
        6486
    ],
    "rumai palaung": [
        6486
    ],
    "réunion french creole": [
        6490
    ],
    "réunionnais": [
        6490
    ],
    "rénioné": [
        6490
    ],
    "réunion creole french": [
        6490
    ],
    "rudbari": [
        6491
    ],
    "rerau": [
        6492
    ],
    "rembong": [
        6493
    ],
    "rejang": [
        6497,
        6498,
        6494
    ],
    "rejang kajan": [
        6494
    ],
    "rejang kayan": [
        6494
    ],
    "regi": [
        6495
    ],
    "reli": [
        6496
    ],
    "relli": [
        6496
    ],
    "redjang": [
        6497,
        6498
    ],
    "rendille": [
        6499
    ],
    "renꞌdille": [
        6499
    ],
    "randile": [
        6499
    ],
    "rendile": [
        6499
    ],
    "rengao": [
        6501
    ],
    "ro-ngao": [
        6501
    ],
    "rer bare": [
        6502
    ],
    "rer": [
        6502
    ],
    "reshe": [
        6503
    ],
    "reta": [
        6504
    ],
    "retta": [
        6504
    ],
    "reyesano": [
        6505
    ],
    "roria": [
        6506
    ],
    "romano-greek": [
        6507
    ],
    "romika": [
        6507
    ],
    "rangkas": [
        6508,
        6572
    ],
    "romagnol": [
        6509
    ],
    "rumagnol": [
        6509
    ],
    "resígaro": [
        6510
    ],
    "resígero": [
        6510
    ],
    "roglai, southern": [
        6511
    ],
    "roglai": [
        6511,
        6582,
        6586
    ],
    "rikou": [
        6512
    ],
    "ringgou": [
        6512
    ],
    "rohingya": [
        6513,
        6514,
        6515
    ],
    "rohinga": [
        6513,
        6514,
        6515
    ],
    "rohinja": [
        6513,
        6514,
        6515
    ],
    "ruwainggya": [
        6513,
        6514,
        6515
    ],
    "ruruhi’ip": [
        6516
    ],
    "riang": [
        6517,
        6523,
        8804
    ],
    "reang": [
        6517
    ],
    "riang (india)": [
        6517
    ],
    "rien": [
        6518
    ],
    "rif": [
        6519,
        6520,
        6521,
        6522
    ],
    "rif berber": [
        6519,
        6520,
        6521,
        6522
    ],
    "rifeño": [
        6519,
        6520,
        6521,
        6522
    ],
    "riff": [
        6519,
        6520,
        6521,
        6522
    ],
    "rifia": [
        6519,
        6520,
        6521,
        6522
    ],
    "rifiya": [
        6519,
        6520,
        6521,
        6522
    ],
    "ruafa": [
        6519,
        6520,
        6521,
        6522
    ],
    "riang lang": [
        6523
    ],
    "riang (myanmar)": [
        6523
    ],
    "remi": [
        6524
    ],
    "rimi": [
        6524
    ],
    "rendre": [
        6525
    ],
    "rindiri": [
        6525
    ],
    "rindre": [
        6525
    ],
    "ribun": [
        6526
    ],
    "ritharrngu": [
        6527
    ],
    "ridarngo": [
        6527
    ],
    "ridarngu": [
        6527
    ],
    "ridharrngu": [
        6527
    ],
    "ritarnugu": [
        6527
    ],
    "ritarungo": [
        6527
    ],
    "ritharngu": [
        6527
    ],
    "riung": [
        6528
    ],
    "rajong": [
        6529
    ],
    "razong": [
        6529
    ],
    "rajibar": [
        6530
    ],
    "rawati": [
        6530
    ],
    "rjya": [
        6530
    ],
    "rajbanshi": [
        6531,
        6537
    ],
    "rajbangsi": [
        6531,
        6537
    ],
    "rajbansi": [
        6531,
        6537
    ],
    "rikbaktsa": [
        6533
    ],
    "rikpakcá": [
        6533
    ],
    "rikpaktsá": [
        6533
    ],
    "rakahanga-manihiki": [
        6534
    ],
    "rakhine": [
        6535
    ],
    "rakhain": [
        6535
    ],
    "rakhaing": [
        6535
    ],
    "rakkhaine": [
        6535
    ],
    "rangpuri": [
        6537
    ],
    "rajbongshi": [
        6537
    ],
    "romansh": [
        6539
    ],
    "rumantsch": [
        6539
    ],
    "rheto-romance": [
        6539
    ],
    "romanche": [
        6539
    ],
    "romansch": [
        6539
    ],
    "rama": [
        6540
    ],
    "rembarrnga": [
        6541
    ],
    "rainbargo": [
        6541
    ],
    "rembarnga": [
        6541
    ],
    "rembarranga": [
        6541
    ],
    "rembarrunga": [
        6541
    ],
    "rembarunga": [
        6541
    ],
    "romani, carpathian": [
        6542
    ],
    "roma": [
        6552,
        6545,
        6550,
        6551,
        6553,
        6554,
        6555,
        6558,
        6561,
        6563,
        6588,
        6590,
        6626,
        6542
    ],
    "romanes": [
        6542,
        6544,
        6556
    ],
    "romungro": [
        6542
    ],
    "romá": [
        6542,
        6556
    ],
    "rodi": [
        6543,
        6546
    ],
    "rotwelsch": [
        6543
    ],
    "romani english": [
        6544
    ],
    "romani mixed dialect": [
        6544
    ],
    "romanichal": [
        6544
    ],
    "romanis": [
        6544
    ],
    "romano lavo": [
        6544
    ],
    "romano": [
        6544
    ],
    "romany": [
        6588,
        6589,
        6544,
        6590
    ],
    "rummaness": [
        6544
    ],
    "romani, kalo finnish": [
        6545
    ],
    "rómma": [
        6545
    ],
    "romkun": [
        6549
    ],
    "romaken": [
        6549
    ],
    "romkuin": [
        6549
    ],
    "romani, baltic": [
        6550,
        6551
    ],
    "romang": [
        6552
    ],
    "romani, balkan": [
        6553,
        6554,
        6555
    ],
    "romani ćhib": [
        6553,
        6554,
        6555
    ],
    "rs": [
        6553,
        6601,
        6829,
        7088,
        7090,
        7092,
        8906
    ],
    "romani, sinte": [
        6556
    ],
    "rempi": [
        6557
    ],
    "rempin": [
        6557
    ],
    "romanó": [
        6558
    ],
    "romanian sign language": [
        6559
    ],
    "romanian": [
        6559,
        6575,
        6576,
        6577,
        6578,
        6579,
        6580,
        6626,
        6629,
        6627,
        6628
    ],
    "române": [
        6559
    ],
    "romanesc": [
        6559
    ],
    "romania": [
        6627,
        6628,
        6559,
        6575,
        6576,
        6578,
        6579,
        6588,
        6589,
        7096
    ],
    "romani, tavringer": [
        6561
    ],
    "resande romani": [
        6561
    ],
    "resande": [
        6561
    ],
    "rommani": [
        6561
    ],
    "romanova": [
        6562
    ],
    "romani, welsh": [
        6563
    ],
    "romnimus": [
        6563
    ],
    "romam": [
        6564
    ],
    "ro mam": [
        6564
    ],
    "rundi": [
        6566,
        6567
    ],
    "ru-unda": [
        6568
    ],
    "ruwund": [
        6568
    ],
    "ronga": [
        6569
    ],
    "rhonga": [
        6569
    ],
    "ranglong": [
        6570
    ],
    "riam chong": [
        6570
    ],
    "riam": [
        6570
    ],
    "ronglong": [
        6570
    ],
    "roon": [
        6571
    ],
    "rongpo": [
        6572
    ],
    "rang po bhasa": [
        6572
    ],
    "rangpa": [
        6572
    ],
    "rungwa": [
        6574
    ],
    "runga": [
        6594,
        6574
    ],
    "română": [
        6575,
        6580,
        6577,
        6576,
        6578,
        6579
    ],
    "româneşte": [
        6575,
        6578
    ],
    "roumanian": [
        6575,
        6576,
        6577,
        6578,
        6579
    ],
    "rumanian": [
        6575,
        6576,
        6577,
        6578,
        6579
    ],
    "rongkong": [
        6581
    ],
    "rongkong-luwu": [
        6581
    ],
    "roglai, cacgia": [
        6582
    ],
    "ra-glai": [
        6582,
        6586
    ],
    "rogo": [
        6583
    ],
    "roinji": [
        6584
    ],
    "ronji": [
        6584
    ],
    "rombo": [
        6585
    ],
    "roglai, northern": [
        6586
    ],
    "radlai": [
        6586
    ],
    "rang glai": [
        6586
    ],
    "rayglay": [
        6586
    ],
    "romblomanon": [
        6587
    ],
    "rumblumãnun": [
        6587
    ],
    "rombloanon": [
        6587
    ],
    "romblon": [
        6587
    ],
    "rom": [
        7395,
        6588,
        6590
    ],
    "romanese": [
        6588,
        6590
    ],
    "romani, vlax": [
        6590,
        6588
    ],
    "romanés": [
        6588,
        6590
    ],
    "rotokas": [
        6591
    ],
    "rotokas reo": [
        6591
    ],
    "roper-bamyili creole": [
        6592
    ],
    "roper-bamyili": [
        6592
    ],
    "rongga": [
        6593
    ],
    "rounga": [
        6594
    ],
    "roungo": [
        6594
    ],
    "runga de ndele": [
        6594
    ],
    "rote dela": [
        6595
    ],
    "repanbitip": [
        6596
    ],
    "rapting": [
        6597
    ],
    "ririo": [
        6598
    ],
    "roro": [
        6599
    ],
    "romano-serbian": [
        6601
    ],
    "rennellese sign language": [
        6602
    ],
    "russian sign language": [
        6603
    ],
    "rsl": [
        6603
    ],
    "rungtu": [
        6605
    ],
    "rungtu chin": [
        6605
    ],
    "ratahan": [
        6606
    ],
    "rotuman": [
        6607
    ],
    "rotuna": [
        6607
    ],
    "rutuman": [
        6607
    ],
    "rathawi": [
        6609
    ],
    "rosiysʹkyy": [
        6610,
        6612
    ],
    "rossiya": [
        6610,
        6612
    ],
    "rosyjski": [
        6610,
        6612
    ],
    "rusija": [
        6610,
        6612
    ],
    "rusijos": [
        6610,
        6612
    ],
    "russ": [
        6610,
        6612
    ],
    "russit": [
        6610,
        6612
    ],
    "rugungu": [
        6617
    ],
    "ruruuli-runyala": [
        6618
    ],
    "ruli": [
        6618
    ],
    "ruluuli": [
        6618
    ],
    "ruluuli-runyala": [
        6618
    ],
    "rurulim": [
        6618
    ],
    "ruuli": [
        6618
    ],
    "ruuli-nyala": [
        6618
    ],
    "rusyn": [
        6619,
        6620
    ],
    "rusinskiy yazyk": [
        6619,
        6620
    ],
    "rusinskiy": [
        6619,
        6620
    ],
    "rusynski": [
        6619,
        6620
    ],
    "ruguru": [
        6621
    ],
    "roviana": [
        6622
    ],
    "robiana": [
        6622
    ],
    "rubiana": [
        6622
    ],
    "ruviana": [
        6622
    ],
    "ruga": [
        6623
    ],
    "rufiji": [
        6624
    ],
    "ruihi": [
        6624
    ],
    "rukuba": [
        6625
    ],
    "romanian, istro": [
        6626
    ],
    "romanian, megleno": [
        6629
    ],
    "rutul": [
        6630,
        6631
    ],
    "rutal": [
        6630,
        6631
    ],
    "rutultsy": [
        6630,
        6631
    ],
    "rutuly": [
        6630,
        6631
    ],
    "rumaiya": [
        6633
    ],
    "rumaya": [
        6633
    ],
    "ruma": [
        6634
    ],
    "rurama": [
        6634
    ],
    "ruruma": [
        6634
    ],
    "ruanda": [
        6635,
        6636
    ],
    "rufumbira": [
        6635,
        6636
    ],
    "runyarwanda": [
        6635,
        6636
    ],
    "rwandan": [
        6635,
        6636
    ],
    "rawo": [
        6637
    ],
    "rwa": [
        6638
    ],
    "rwo": [
        6638
    ],
    "ruwila": [
        6639
    ],
    "rwila": [
        6639
    ],
    "ruwenzori kibira": [
        6640
    ],
    "ruwenzori": [
        6640
    ],
    "rwamba": [
        6640
    ],
    "rawa": [
        6641,
        6642
    ],
    "raua": [
        6641,
        6642
    ],
    "rawa mande": [
        6641,
        6642
    ],
    "rajsthani": [
        6643
    ],
    "rāziḥī": [
        6649
    ],
    "razih": [
        6649
    ],
    "rāziḥīt": [
        6649
    ],
    "rāziḥ": [
        6649
    ],
    "rar": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "rori": [
        6706
    ],
    "ruc": [
        6719
    ],
    "rueal": [
        6736
    ],
    "rotea": [
        6777
    ],
    "roteang": [
        6777
    ],
    "rơtéang": [
        6777
    ],
    "raphael": [
        6915
    ],
    "rishaidep": [
        6973
    ],
    "russian lapp": [
        6980
    ],
    "riverain": [
        6999
    ],
    "riverain sango": [
        6999
    ],
    "romande": [
        7146
    ],
    "ray": [
        7163
    ],
    "rangah": [
        7165
    ],
    "ruotsi": [
        7209,
        7211
    ],
    "reci": [
        7219
    ],
    "reči": [
        7219
    ],
    "rarua": [
        7262
    ],
    "rarómari raicha": [
        7303
    ],
    "rarómari": [
        7303
    ],
    "raicha": [
        7303,
        7318,
        7373
    ],
    "ralámuli de la baja tarahumara": [
        7303
    ],
    "ralámuli": [
        7303,
        7318
    ],
    "rarámuri": [
        7303
    ],
    "rocoroibo": [
        7303
    ],
    "rungu": [
        7315
    ],
    "ralámuli de la tarahumara alta": [
        7318
    ],
    "ralámuli raicha": [
        7318
    ],
    "raepa tati": [
        7331
    ],
    "raepa": [
        7331
    ],
    "rouku": [
        7363
    ],
    "reu": [
        7368
    ],
    "rau": [
        7372,
        7849,
        9184
    ],
    "rarámari raicha": [
        7373
    ],
    "rarámari": [
        7373
    ],
    "rone": [
        7424
    ],
    "ronge": [
        7424
    ],
    "rana": [
        7482,
        8339
    ],
    "rana thakur": [
        7482
    ],
    "rana tharu": [
        7482
    ],
    "red tai": [
        7524,
        7870
    ],
    "río": [
        7551
    ],
    "retuama": [
        7617
    ],
    "retuarã": [
        7617
    ],
    "rutooro": [
        7764
    ],
    "rutoro": [
        7764
    ],
    "rorovana": [
        7776
    ],
    "rodela": [
        7786
    ],
    "rogue": [
        7799
    ],
    "rau jarjar": [
        7849
    ],
    "reo tahiti": [
        7860
    ],
    "red thai": [
        7870
    ],
    "rouge": [
        7870
    ],
    "rabaul creole german": [
        7953
    ],
    "rabaul": [
        7953
    ],
    "ramo": [
        7972
    ],
    "ramarama-urumí": [
        8008
    ],
    "rattiyan": [
        8045
    ],
    "roucouyenne": [
        8173
    ],
    "rawngtu": [
        8214
    ],
    "rawngtu chin": [
        8214
    ],
    "rongtu": [
        8214
    ],
    "rangwa": [
        8219
    ],
    "radu yor": [
        8275
    ],
    "raduyor": [
        8275
    ],
    "raetic": [
        8623
    ],
    "ravula": [
        8768,
        8769
    ],
    "reiwo": [
        8779
    ],
    "riang lai": [
        8804
    ],
    "roi": [
        8804
    ],
    "ranei": [
        8804
    ],
    "red riang": [
        8804
    ],
    "riang saek": [
        8804
    ],
    "riang sak": [
        8804
    ],
    "ren": [
        8821,
        8916
    ],
    "rossel": [
        8829
    ],
    "rahanween": [
        8849
    ],
    "rahanweyn": [
        8849
    ],
    "rikwa": [
        8937
    ],
    "rankbirit": [
        8959
    ],
    "ruoke": [
        8965
    ],
    "raorou": [
        8981
    ],
    "rourou": [
        8981
    ],
    "rincón": [
        8986,
        9158
    ],
    "rincón zapotec": [
        8986
    ],
    "rimang-gudinhma": [
        9102
    ],
    "rimanggudinhma": [
        9102
    ],
    "rayón": [
        9118
    ],
    "rayón zoque": [
        9118
    ],
    "rii": [
        9132
    ],
    "rixhquei": [
        9145
    ],
    "rincon": [
        9158
    ],
    "raymundo": [
        9170
    ]
};
